export enum ThirdPartiesFileExtension {
  Cnh = 1,
  Crlv = 2,
  DamageImages = 3
}